import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  template: `
    <div [nbTooltipDisabled]="!data.tooltip" [nbTooltip]="data.tooltip" nbTooltipStatus="default" (dblclick)="copyToClipboard($event)" nbTooltipPlacement="bottom"
      [ngStyle]="data.style">
      {{ data.value }}
      @if ((data.link || data.serviceName || data.route) && !loading) {
        <nb-icon class="ms-1" icon="external-link-outline" (click)="goToLink($event)"
        [nbTooltipDisabled]="!data.iconTooltip" [nbTooltip]="data.iconTooltip" nbTooltipStatus="default" nbTooltipPlacement="right"></nb-icon>
      }
      @if (loading) {
        <i class="fa fa-spinner fa-spin ms-1"></i>
      }
    </div>
    `,
  styleUrls: ['./tooltip-cell.component.scss'],
})
export class TooltipCellComponent {
  @Input()
  data: any;
  loading: boolean = false;

  constructor(
    private router: Router
  ) {}

  goToLink(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.data.link) {
      window.open(this.data.link, '_blank');
    } else if (this.data.route) {
      // ctrlKey for windows, metaKey is Command key in MacOs
      if (event.ctrlKey || event.metaKey) {
        const urlTree = this.router.createUrlTree([this.data.route], { queryParams: { ignorePreviousParams: true } });
        const urlString = this.router.serializeUrl(urlTree);
        window.open(urlString, '_blank');
      } else {
        if (this.data.routeLoading) {
          this.data.routeLoading();
        }
        this.router.navigate([this.data.route], { queryParams: { ignorePreviousParams: true } });
      }
    }
  }

  copyToClipboard($event: any) {
    navigator.clipboard.writeText($event.target.textContent.replace(/\s+/g, ''));

    $event.target.classList.add('highlight');
    setTimeout(() => {
      $event.target.classList.remove('highlight');
    }, 300);
  }
}
